import { zIndex } from 'helper/Style';

export type OperationFilterProps = Readonly<{
  display: boolean;
  zIndex?: number;
  className?: string;
  onHide: () => void | Promise<void>;
  children?: React.JSX.Element | React.JSX.Element[];
}>;

const style = {
  position: 'fixed' as const,
  top: '0',
  left: '0',
  width: '100vw',
  height: '100vh !important',
  'z-index': zIndex.filter,
  '&:not([data-active="1"])': {
    display: 'none',
  },
};

const OperationFilter = (props: OperationFilterProps) =>
  <div
    data-active={props.display ? '1' : '0'}
    onClick={() => props.onHide()}
    css={style}
    className={props.className}
  >
    {props.children}
  </div>;

export default OperationFilter;
